const apiEnvironment = (window as any)?.bootstrap?.apiEnvironment;

const dev2: AuthSettings = {
    REACT_APP_AUDIENCE: 'cpg-business-api-dev2',
    REACT_APP_CLIENT_ID: 'qECpEt1Xeyap3ihSdODVi64YRUbCpdJn',
    REACT_APP_CONNECTION: 'cpg-to-auth0-database',
    REACT_APP_DOMAIN: 'cpg-dev2.us.auth0.com',

    REACT_APP_AUTH0_LOGOUT_URL: 'https://signin-dev2.cpg.org/auth/logout',
    REACT_APP_CPG_LOGOUT_URL: 'https://signin-dev2.cpg.org/auth/logout',

    REACT_APP_MULESOFT_URL: 'https://dev2.enterprise-api.cpg.org/',

    REACT_APP_SESSION_COUNTDOWN: 120,
    REACT_APP_SESSION_TIMEOUT: 1080,
    REACT_APP_SESSION_THROTTLE: 300,

};

const test1: AuthSettings = {
    REACT_APP_AUDIENCE: 'cpg-business-api-test1',
    REACT_APP_CLIENT_ID: 'HnUSn8HMyu3eDG6yEWBJiTNknLKWDXmJ',
    REACT_APP_CONNECTION: 'cpg-to-auth0-database',
    REACT_APP_DOMAIN: 'authenticate-test.cpg.org',

    REACT_APP_AUTH0_LOGOUT_URL: 'https://signin-test.cpg.org/auth/logout',
    REACT_APP_CPG_LOGOUT_URL: 'https://signin-test.cpg.org/auth/logout',

    REACT_APP_MULESOFT_URL: 'https://test1.enterprise-api.cpg.org/',

    REACT_APP_SESSION_COUNTDOWN: 120,
    REACT_APP_SESSION_TIMEOUT: 1080,
    REACT_APP_SESSION_THROTTLE: 300,
};

const test2: AuthSettings = {
    REACT_APP_AUDIENCE: 'cpg-business-api-test2',
    REACT_APP_CLIENT_ID: 'TQqfAy84pjDQg4cohWyHKt5rXI3CQCPG',
    REACT_APP_CONNECTION: 'cpg-to-auth0-database',
    REACT_APP_DOMAIN: 'cpg-test2.us.auth0.com',

    REACT_APP_AUTH0_LOGOUT_URL: 'https://signin-qa.cpg.org/auth/logout',
    REACT_APP_CPG_LOGOUT_URL: 'https://signin-qa.cpg.org/auth/logout',

    REACT_APP_MULESOFT_URL: 'https://test2.enterprise-api.cpg.org/',

    REACT_APP_SESSION_COUNTDOWN: 120,
    REACT_APP_SESSION_TIMEOUT: 1080,
    REACT_APP_SESSION_THROTTLE: 300,
};

const sandbox: AuthSettings = {
    REACT_APP_AUDIENCE: 'cpg-business-api-sandbox',
    REACT_APP_CLIENT_ID: 'x2Nj59dDgVivVGzIO3eaxaUBPOZ77uqJ',
    REACT_APP_CONNECTION: 'cpg-to-auth0-database',
    REACT_APP_DOMAIN: 'authenticate-sandbox.cpg.org',
    REACT_APP_AUTH0_LOGOUT_URL: 'https://signin-sandbox.cpg.org/auth/logout',
    REACT_APP_CPG_LOGOUT_URL: 'https://signin-sandbox.cpg.org/auth/logout',
    REACT_APP_MULESOFT_URL: 'https://sbox.enterprise-api.cpg.org/',
    REACT_APP_SESSION_COUNTDOWN: 120,
    REACT_APP_SESSION_TIMEOUT: 1080,
    REACT_APP_SESSION_THROTTLE: 300,
};

const prod: AuthSettings = {
    REACT_APP_AUDIENCE: 'cpg-business-api-prod',
    REACT_APP_CLIENT_ID: '0ztNsmrMAFndynzDvplT1y9mxXm7mAc7',
    REACT_APP_CONNECTION: 'cpg-to-auth0-database',
    REACT_APP_DOMAIN: 'authenticate.cpg.org',

    REACT_APP_AUTH0_LOGOUT_URL: 'https://signin.cpg.org/auth/logout',
    REACT_APP_CPG_LOGOUT_URL: 'https://signin.cpg.org/auth/logout',

    REACT_APP_MULESOFT_URL: 'https://enterprise-api.cpg.org/',

    REACT_APP_SESSION_COUNTDOWN: 120,
    REACT_APP_SESSION_TIMEOUT: 1080,
    REACT_APP_SESSION_THROTTLE: 300,
};


interface AuthSettings {
    REACT_APP_AUDIENCE: string;
    REACT_APP_CLIENT_ID: string;
    REACT_APP_CONNECTION: string;
    REACT_APP_DOMAIN: string;

    REACT_APP_AUTH0_LOGOUT_URL: string;
    REACT_APP_CPG_LOGOUT_URL: string;

    REACT_APP_MULESOFT_URL: string;

    REACT_APP_SESSION_COUNTDOWN: number;
    REACT_APP_SESSION_TIMEOUT: number;
    REACT_APP_SESSION_THROTTLE: number;
}

const AuthSettingsCollection = {
    dev2,
    test1,
    test2,
    sandbox,
    prod,
};

const defaultAuthSettings = 'dev2';

export const AuthSetting = AuthSettingsCollection[apiEnvironment || defaultAuthSettings] as AuthSettings;